import { Component } from '@angular/core';
import { NavController, Platform, ToastController } from '@ionic/angular';
import { StatusBar } from '@awesome-cordova-plugins/status-bar/ngx';
import { SplashScreen } from '@awesome-cordova-plugins/splash-screen/ngx';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent {

  constructor(
    public navController: NavController,
    public toastController: ToastController,
    public statusBar: StatusBar,
    public platform: Platform,
    public splashScreen: SplashScreen,
  ) {
    this.initializeApp();
  }

  initializeApp() {
    this.platform.ready().then(() => {
      if (this.platform.is('cordova')) {
        this.statusBar.backgroundColorByHexString('#4a1dc1');
        this.statusBar.styleBlackOpaque();
        this.splashScreen.hide();
      }
    });
  }


}
